import {
  CoreApi,
  StyleCreateRequest,
  StyleResponse,
  StyleUpdateRequest,
  BlobContentType,
  ImportStyleDataRequest,
  IdKeyType,
  StyleRequest,
  StyleFeatureResponse,
} from "@hokuto/jam-core";
import {
  SearchFeatureApi,
  fetchBlob,
  fetchJSON,
  fetchUpload,
} from "./fetch.js";
import { ApiMethod } from "../types.js";

export const StyleApi = {
  Search: new SearchFeatureApi<
    StyleRequest,
    StyleResponse,
    StyleFeatureResponse
  >(CoreApi.Style.Search),

  Create: fetchJSON<StyleCreateRequest, StyleResponse>(
    CoreApi.Style.Create,
    ApiMethod.Post
  ),
  Read: fetchJSON<StyleRequest, StyleResponse>(CoreApi.Style.Read),
  Update: fetchJSON<StyleUpdateRequest, StyleResponse>(
    CoreApi.Style.Update,
    ApiMethod.Put
  ),
  Delete: fetchJSON<StyleRequest>(CoreApi.Style.Delete, ApiMethod.Delete),
  Clone: fetchJSON<StyleRequest, StyleResponse>(
    CoreApi.Style.Clone,
    ApiMethod.Post
  ),
  Export: fetchBlob<StyleRequest>(CoreApi.Style.Export, BlobContentType.Json),
  Import: fetchUpload<ImportStyleDataRequest, { [IdKeyType.Style]: string }>(
    CoreApi.Style.Import
  ),
  Load: fetchUpload<ImportStyleDataRequest, { [IdKeyType.Style]: string }>(
    CoreApi.Style.Load
  ),
};
